import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Flex, Text } from '@chakra-ui/react';
import { FT_PI_SUMMER_SALE_PROMO_BANNER } from '@whitbread-eos/api';
import { Alert, ChevronDown24, ChevronUp24, Icon, Notification } from '@whitbread-eos/atoms';
import { useFeatureToggle, renderSanitizedHtml, formatAssetsUrl } from '@whitbread-eos/utils';
import { useState, useEffect } from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function SummerPromo(_ref) {
  var promotionBanner = _ref.promotionBanner,
    showNotification = _ref.showNotification;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showMore = _useState2[0],
    setShowMore = _useState2[1];
  var _useFeatureToggle = useFeatureToggle(),
    isSummerPromoCodeEnabled = _useFeatureToggle[FT_PI_SUMMER_SALE_PROMO_BANNER];
  var bannerInfo = promotionBanner;
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    width = _useState4[0],
    setWidth = _useState4[1];
  var isMdWidth = width >= 768;
  var _useState5 = useState(true),
    _useState6 = _slicedToArray(_useState5, 2),
    hasCellCodes = _useState6[0],
    setHasCellCode = _useState6[1];
  useEffect(() => {
    setWidth(window.innerWidth);
    var handleResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  useEffect(() => {
    var search = window.location.search;
    var searchParameters = new URLSearchParams(search);
    setHasCellCode(searchParameters.has('CELLCODES') || searchParameters.has('CORPID') || searchParameters.has('PROMOID'));
  }, []);
  if (!hasCellCodes && bannerInfo !== null && bannerInfo !== void 0 && bannerInfo.enabled && isSummerPromoCodeEnabled) {
    var termsLink = _jsx("span", {
      style: _objectSpread({}, bannerTermsStyles),
      children: renderSanitizedHtml(bannerInfo === null || bannerInfo === void 0 ? void 0 : bannerInfo.terms)
    });
    return _jsxs(Flex, _objectSpread(_objectSpread({
      "data-testid": "SummerPromoContainer"
    }, bannerContainerStyles), {}, {
      children: [_jsxs(Box, _objectSpread(_objectSpread({}, boxContainerStyles), {}, {
        children: [_jsxs(Text, _objectSpread(_objectSpread({
          as: "div"
        }, bannerTitleStyles), {}, {
          fontSize: "lg",
          fontWeight: "bold",
          children: [_jsxs(Box, _objectSpread(_objectSpread({}, bannerTitleBoxStyles), {}, {
            children: [_jsx(Icon, {
              src: formatAssetsUrl(bannerInfo === null || bannerInfo === void 0 ? void 0 : bannerInfo.icon),
              style: _objectSpread({}, bannerIcon)
            }), bannerInfo === null || bannerInfo === void 0 ? void 0 : bannerInfo.title]
          })), _jsx(Box, _objectSpread(_objectSpread({}, cheveronContainerStyles), {}, {
            "data-testid": "chevronIconContainer",
            children: showMore ? _jsx(ChevronUp24, {
              color: "#FDB913",
              onClick: () => setShowMore(false),
              "data-testid": "chevronUpIcon"
            }) : _jsx(ChevronDown24, {
              color: "#FDB913",
              onClick: () => setShowMore(true),
              "data-testid": "chevronDownIcon"
            })
          }))]
        })), _jsxs(Text, {
          as: "div",
          color: "white",
          fontSize: "sm",
          style: showMore || isMdWidth ? {
            display: 'block'
          } : hideTextStyles,
          children: [bannerInfo === null || bannerInfo === void 0 ? void 0 : bannerInfo.description, " ", showNotification ? termsLink : null, !showNotification && !isMdWidth && _jsx(Box, {
            "data-testid": "termsLink",
            children: termsLink
          })]
        })]
      })), _jsx(Box, _objectSpread(_objectSpread({}, notificationBoxStyles), {}, {
        children: showNotification ? _jsx(Notification, {
          variant: "alert",
          status: "warning",
          title: promotionBanner === null || promotionBanner === void 0 ? void 0 : promotionBanner.srpNotificationTitle,
          description: promotionBanner === null || promotionBanner === void 0 ? void 0 : promotionBanner.srpNotificationText,
          svg: _jsx(Alert, {}),
          isInnerHTML: true,
          wrapperStyles: wrapperStyles,
          style: notificationTextStyles
        }) : isMdWidth ? termsLink : null
      }))]
    }));
  }
  return null;
}
var bannerContainerStyles = {
  backgroundColor: '#511E62',
  display: 'grid',
  gridTemplateColumns: {
    base: '1fr',
    md: '1fr 1fr'
  },
  px: {
    base: '1rem',
    md: '1.5rem',
    xl: '66px'
  },
  py: {
    base: '0.75rem',
    md: '0.5rem'
  }
};
var bannerTitleBoxStyles = {
  display: 'flex',
  alignItems: 'center'
};
var bannerTitleStyles = {
  color: '#FDB913',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between'
};
var bannerTermsStyles = {
  textDecoration: 'underline',
  pointer: 'cursor',
  color: 'white',
  fontSize: 'sm'
};
var bannerIcon = {
  display: 'inline',
  width: '16px',
  height: '16px',
  marginRight: '6px'
};
var hideTextStyles = {
  display: 'none'
};
var cheveronContainerStyles = {
  display: {
    sm: 'block',
    md: 'none'
  }
};
var boxContainerStyles = {};
var notificationBoxStyles = {
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  color: 'white',
  width: {
    xs: 'full',
    md: 'auto'
  }
};
var wrapperStyles = {
  padding: {
    xs: '6px 8px',
    md: '6px 24px 6px 12px'
  },
  width: {
    xs: 'full',
    md: 'auto'
  },
  marginTop: {
    xs: '5px',
    md: '0'
  },
  alignItems: 'center'
};
var notificationTextStyles = {
  fontSize: '13px',
  lineHeight: '150%',
  fontWeight: '700'
};